<template>
  <div class="advert_box">
    <van-swipe v-if="!!adList" :show-indicators="false" :loop="false">
      <van-swipe-item v-for="(item, index) in adList" :key="index">
        <div class="ad_item" @click="toAd(item)">
          <div class="ad_title">
            <span v-text="item.title"></span>
          </div>
          <div class="ad_img_box">
            <div class="ad_img">
              <img v-if="item.imgUrl.length > 0" :src="item.imgUrl" alt="" :onerror="imgLoadError(item)" />
            </div>
          </div>
          <div class="theme_tg">广告</div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { deepClone, getUrlParamObj } from "@/utils";
export default {
  name: "Advert",
  props: {
    ads: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      adList: [],
    };
  },
  watch: {
    ads: {
      handler(newValue, oldValue) {
        this.adList = deepClone(newValue);
      },
      deep: true,
    },
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 跳转广告详情 */
    toAd(item) {
      if (!!item.link && item.link.length > 0) {
        window.open(item.link, "_blank");
      } else if (item.shareUrl.indexOf("/#/index_share?") > -1) {
        let query = getUrlParamObj(item.shareUrl);
        if (!!this.headerHidden) {
          query = Object.assign(query, { client: 1 });
        }
        this.$router.push({
          path: "/index_share",
          query: query,
        });
      }
    },
  },
  created() {
    this.adList = deepClone(this.ads);
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
};
</script>
<style scoped lang="scss">
.advert_box {
  padding-top: 15px;
  margin-bottom: 16px;
  .van-swipe {
    width: 100%;
    height: 100%;
    .ad_item {
      .ad_title {
        max-height: 22.5px;
        line-height: 22.5px;
        padding: 0;
        margin-bottom: 8px;
        overflow: hidden;
        color: #1a1a1a;
        font-size: 16px;
        font-weight: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .ad_img_box {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
        border-radius: 5px;
        overflow: hidden;
        .ad_img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-image: url(~@/assets/images/default_pic_16_9.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          display: flex;
          justify-content: center;
          img {
            object-fit: cover;
            min-width: 100%;
            min-height: 100%;
          }
        }
      }
      .theme_tg {
        display: inline-block;
        padding: 3px;
        margin-top: 8px;
        color: #a1a1a1;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        border: 1px solid #ededed;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
}
</style>